<template>
  <b-container>
    <config-publisher
      ref="configPublisher"
      v-model="config"
      class="p-0"
      tool-name="Web View Configuration"
      :config-name="configName"
      :can-edit="canWebviewEdit"
      :can-publish="canWebviewPublish"
      :is-form-valid="isFormValid">
      <template slot="header" />
      <web-view-form
        :key="componentKey"
        ref="webviewForm"
        v-model="config.tab" />
      <b-card
        :key="`override-${componentKey}`"
        title="Overrides">
        <web-view-override-selection
          v-model="config.dates"
          class="mt-2" />
      </b-card>
      <b-card
        :key="`scoreboard-override-${componentKey}`"
        title="Scoreboard Overrides"
        class="my-4">
        <web-view-scoreboard-override-selection
          v-model="config.scoreboard"
          class="mt-2" />
      </b-card>
    </config-publisher>
  </b-container>
</template>

<script>
  import ConfigPublisher from "@/components/ConfigPublisher"
  import WebViewForm from "@/components/WebView/WebViewForm"
  import {mapGetters} from "vuex"
  import WebViewOverrideSelection from "@/components/WebView/WebViewOverrideSelection"
  import WebViewScoreboardOverrideSelection from "@/components/WebView/WebViewScoreboardOverrideSelection"

  export default {
    name: "WebView",
    components: {
      ConfigPublisher,
      WebViewScoreboardOverrideSelection,
      WebViewOverrideSelection,
      WebViewForm,
    },
    data: () => ({
      componentKey: 1,
      config: {},
      betaConfig: {},
      prodConfig: {},
      betaUrl: null,
      prodUrl: null,
      showPublishModal: false,
      configName: "webview",
    }),
    computed: {
      ...mapGetters([
        'betaEnvName',
        'liveEnvName',
        'isAdmin',
        'canWebviewEdit',
        'canWebviewPublish',
      ]),
    },
    methods: {
      isFormValid() {
        return this.$refs.webviewForm && this.$refs.webviewForm.isValid()
      },
    },
    async beforeRouteLeave(to, from, next) {
      if (this.$refs.configPublisher.configHasChanged()) {
        const message = `You have unpublished changes to your config, which will be lost.\n\nClick "Cancel" to go back and publish your work, or click "Yes" to lose your changes.`
        next(await this.$confirm.open(message))
      } else {
        next()
      }
    },
  }
</script>

<style scoped>

</style>
